import { FC, Suspense } from 'react';
import './i18n';

export const I18nProvider: FC = ({ children }) => {
  return <Suspense fallback={null}>{children}</Suspense>;
};
